import { getMsalInstance } from '../initializeMsalLibrary';

export async function getMsalIdTokenClaims(): Promise<Record<string, unknown> | undefined> {
    const msalInstance = await getMsalInstance();
    return msalInstance.getActiveAccount()?.idTokenClaims;
}
